import React, { useState, useEffect } from "react";
import { IonContent, IonPage, IonButton, IonText } from "@ionic/react";

const SkipCounting: React.FC = () => {
    const [sequence, setSequence] = useState<number[]>([]);
    const [correctAnswer, setCorrectAnswer] = useState<number | null>(null);
    const [options, setOptions] = useState<number[]>([]);
    const [userChoice, setUserChoice] = useState<number | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    const generateSkipCountingQuestion = () => {
        const skipNumber = Math.floor(Math.random() * 5) + 2; // Random skip number (2 to 6)
        const startNumber = Math.floor(Math.random() * 10) + 1; // Random start number (1 to 10)
        const sequenceLength = 4; // Number of visible elements in the sequence

        // Generate the sequence
        const newSequence = Array.from(
            { length: sequenceLength },
            (_, i) => startNumber + i * skipNumber
        );

        // Determine the correct answer (next number in the sequence)
        const nextNumber = startNumber + sequenceLength * skipNumber;

        // Generate incorrect options
        const incorrectOptions = generateIncorrectOptions(nextNumber, skipNumber);

        // Shuffle all options
        const allOptions = shuffleArray([nextNumber, ...incorrectOptions]);

        // Update state
        setSequence(newSequence);
        setCorrectAnswer(nextNumber);
        setOptions(allOptions);
        setUserChoice(null);
        setIsCorrect(null);
    };

    const generateIncorrectOptions = (correct: number, skip: number) => {
        const incorrectOptions = new Set<number>();
        while (incorrectOptions.size < 2) {
            const randomOption = correct + (Math.random() > 0.5 ? skip : -skip) * (Math.floor(Math.random() * 3) + 1);
            if (randomOption !== correct) {
                incorrectOptions.add(randomOption);
            }
        }
        return Array.from(incorrectOptions);
    };

    const shuffleArray = (array: any[]) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    const handleAnswerSubmit = (selected: number) => {
        setUserChoice(selected);
        setIsCorrect(selected === correctAnswer);

        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateSkipCountingQuestion();
                setShowImage(false);
                setError(false);
            }, 5000); // Delay before generating a new question
        }
        else {
            setError(true);
        }
    };

    useEffect(() => {
        generateSkipCountingQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Patterns - Skip Counting"; // Set page title
    }, []);

    return (
        <>
        {
            showImage === false ?
            <>
                <div className="contentPart showCenter additionWord">
                    <div>
                        <div className="">
                            <p style={{ fontSize: "1.5em" }}>
                                {sequence.join(", ")}, ?
                            </p>
                            <div>What comes next?</div>
                            <div className="optionDiv" style={{ marginTop: "20px" }}>
                                {options.map((option, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleAnswerSubmit(option)}
                                        className={`optionButton ${
                                            userChoice === option
                                            ? option === selectedOption
                                                ? 'correct'
                                                : 'incorrect'
                                            : ''
                                                
                                        }`}
                                    >
                                        {option}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <>
                <div className="contentPart showMiddle">
                    <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                </div>
            </>
            }
        </>
    );
};

export default SkipCounting;
